import router from '@/app/plugins/router';
import { authHeader } from '@/config/authHeader';
import { environment } from '@/config/environment';
import { authorizedRequest } from '@/services/ApiService';
import { internalApiRequest } from '@/shared/services/apiService';
import store from '@/store';
import axios from 'axios';

export const updateContract = ({ contractId, contractData }) => {
  return axios
    .put(`${environment.getApiUrl()}/api/v1/contracts/${contractId}`, contractData, {
      headers: { ...authHeader() },
    })
    .then((resp) => resp.data)
    .catch((err) => {
      throw err.response.data;
    });
};

export const fetchContractSignIdentities = (function () {
  return function ({ contractId, attempt, timeout, next, catchError, routeName }) {
    attempt -= 1;
    axios
      .get(`${environment.getApiUrl()}/api/v2/contract/${contractId}/signIdentity/list`, {
        headers: authHeader(),
      })
      .then((resp) => {
        next(resp.data);
      })
      .catch((err) => {
        if (0 === attempt || routeName !== router.currentRoute.name) {
          return catchError(err);
        }

        return setTimeout(function () {
          fetchContractSignIdentities({
            contractId,
            attempt,
            timeout,
            next,
            catchError,
            routeName,
          });
        }, timeout);
      });
  };
})();

export const getContractCheckList = (function () {
  return function ({ contractId, attempt, timeout, next, catchError, routeName }) {
    attempt -= 1;
    authorizedRequest({
      method: 'GET',
      endpoint: `api/v1/contracts/${contractId}/controllist`,
    })
      .then(async (resp) => {
        next(resp);
      })
      .catch((err) => {
        if (0 === attempt || routeName !== router.currentRoute.name) {
          return catchError(err);
        }

        return setTimeout(function () {
          getContractCheckList({
            contractId,
            attempt,
            timeout,
            next,
            catchError,
            routeName,
          });
        }, timeout);
      });
  };
})();

export const getContractAmlRevisionList = (function () {
  return function ({ contractId, attempt = 5, timeout = 2500, next, catchError, routeName }) {
    attempt -= 1;
    authorizedRequest({
      method: 'GET',
      endpoint: `api/v1/auths/contracts/${contractId}/revisionList`,
    })
      .then(async (resp) => {
        next(resp);
      })
      .catch((err) => {
        if (0 === attempt || routeName !== router.currentRoute.name) {
          return catchError(err);
        }

        return setTimeout(function () {
          getContractAmlRevisionList({
            contractId,
            attempt,
            timeout,
            next,
            catchError,
            routeName,
          });
        }, timeout);
      });
  };
})();

export const circularFetchDocumentWithLink = (function () {
  return function ({ contractId, timeout, next, catchError }) {
    authorizedRequest({
      method: 'GET',
      endpoint: `/api/v2/contracts/${contractId}/document`,
    })
      .then(async (resp) => {
        next(resp);
      })
      .catch((err) => {
        if (
          err?.errorCode !== 'Signi.Exceptions.Document.DocumentFailedException' &&
          ['contractView', 'createContent', 'documentsDetail'].includes(router.currentRoute.name) &&
          'doc' === store.getters['contract']?.type
        ) {
          return setTimeout(function () {
            circularFetchDocumentWithLink({
              contractId,
              timeout,
              next,
              catchError,
            });
          }, timeout);
        } else {
          catchError(err);
        }
      });
  };
})();

export const fetchContractDocumentHistory = ({ idContract, idCurrentSignIdentity = null }) => {
  return authorizedRequest({
    method: 'GET',
    endpoint: `api/v2/contract/${idContract}/history${idCurrentSignIdentity ? `/${idCurrentSignIdentity}` : ''}`,
  });
};

export const fetchContractSignatureRoles = (contractId, variablePosition) => {
  return authorizedRequest({
    method: 'GET',
    endpoint: `api/v2/contract/${contractId}/workspace/member/list?variablePosition=${variablePosition}`,
  });
};

export const setUserFromVariableRole = (userId, signIdentityIds) => {
  return authorizedRequest({
    method: 'POST',
    endpoint: `/api/v2/docsPerson/from/user/${userId}`,
    data: {
      signIdentityIds: signIdentityIds,
    },
  });
};

/**
 * @param {Number|String} contractId
 * @param {Number|String} signIdentityId
 * @param {String} note
 * @returns {Promise<AxiosResponse<*>>}
 */
export const approveContractAsRegisteredUser = ({ contractId, signIdentityId, note = null }) => {
  return internalApiRequest({
    method: 'PUT',
    path: `api/v1/contracts/${contractId}/signs/${signIdentityId}/approve`,
    data: {
      approvalNote: note,
    },
  });
};
